import { FinanceDirection } from '../../shared/types';

export const CURRENCY_OPTIONS = ['', 'BTC', 'ETH', 'USDT', 'TRX', 'USD'];

export const TYPE_LABELS: Record<string, string> = {
  credit: 'Credit',
  debit: 'Debit',
  escrow_hold: 'Escrow hold',
  escrow_release_credit: 'Escrow release (received)',
  escrow_release_debit: 'Escrow release (sent)',
  escrow_cancel: 'Escrow cancelled',
  escrow_adjust_increase: 'Escrow increased',
  escrow_adjust_decrease: 'Escrow decreased',
};

const SMALLEST_UNIT_DIVISOR = 100_000_000;

export const formatCryptoAmount = (amount: number | null | undefined): string => {
  if (amount === null || amount === undefined || !Number.isFinite(amount)) return '0';
  return (amount / SMALLEST_UNIT_DIVISOR).toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8,
  });
};

export const formatUsd = (value: number | null | undefined): string => {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const directionPrefix = (direction: FinanceDirection): string =>
  direction === 'in' ? '+' : direction === 'out' ? '−' : '';

export const directionClass = (direction: FinanceDirection): string =>
  direction === 'in'
    ? 'text-emerald-400'
    : direction === 'out'
      ? 'text-rose-400'
      : 'text-amber-400';
